import Icon from '../components/Icon';

const Image = Icon(
  'image',
  <>
    <path d="M8.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
    <path
      fillRule="evenodd"
      d="M2.25 5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19zM5 3.75c-.69 0-1.25.56-1.25 1.25v10.244l1.631-1.631a2.25 2.25 0 0 1 3.177-.005l1.969 1.955 4.47-4.465a2.25 2.25 0 0 1 3.18 0l2.073 2.07V5c0-.69-.56-1.25-1.25-1.25zm15.25 11.536-3.133-3.126a.75.75 0 0 0-1.06 0l-5 4.992a.75.75 0 0 1-1.058.002l-2.498-2.482a.75.75 0 0 0-1.059.001L3.75 17.365V19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25z"
      clipRule="evenodd"
    />
  </>
);

export default Image;
